import {
  TextareaAutosize as BaseTextareaAutosize,
  styled,
} from 'components/base';

const Label = styled('label')(() => ({
  fontFamily: 'Roboto, sans-serif',
  fontSize: 14,
  fontWeight: 500,
  color: '#98a5b9',
  marginBottom: '0.5rem',
  display: 'block',
}));

const StyledTextarea = styled(BaseTextareaAutosize)(() => ({
  boxSizing: 'border-box',
  width: '100%',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 400,
  lineHeight: '1.1876em',
  letterSpacing: '0.00938em',
  padding: '8px 14px',
  borderRadius: 4,
  fontSize: 14,
  color: '#1C2025',
  background: '#fff',
  border: '1px solid #dcdcdc',
  resize: 'none',

  '&::-webkit-scrollbar': {
    width: 7,
    height: 7,
  },
  '&::-webkit-scrollbar-track': {
    background: '#f5f5f5',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#bdbdbd',
    borderRadius: 4,
  },

  '&::placeholder': {
    color: '#ccc!important',
  },

  '&:hover': {
    borderColor: '#f19100',
  },

  '&:focus': {
    borderColor: '#f19100',
  },

  '&:focus-visible': {
    outline: 0,
  },
}));

export { Label, StyledTextarea };
